import { AgGridReact } from 'ag-grid-react';

import useGetChunkTableData from './useGetChunkTableData';

export default function ChunkSummaryTable({
    chunkResults,
    darkMode,
    onViewChunk,
}) {
    const { rowData, columnDefs, defaultColDef } = useGetChunkTableData(
        chunkResults,
        onViewChunk,
    );

    return (
        <div
            className={
                darkMode
                    ? 'ag-theme-material-dark ag-theme-base'
                    : 'ag-theme-material ag-theme-base ag-theme-base-light'
            }
            style={{ width: '100%' }}>
            <AgGridReact
                loadThemeGoogleFonts
                rowData={rowData}
                columnDefs={columnDefs}
                defaultColDef={defaultColDef}
                domLayout="autoHeight"
                headerHeight={36}
                rowHeight={42}
                suppressCellFocus
            />
        </div>
    );
}
